import { render } from "./FridgePushSettingsPage.vue?vue&type=template&id=481e3f6a&scoped=true&ts=true"
import script from "./FridgePushSettingsPage.vue?vue&type=script&lang=ts"
export * from "./FridgePushSettingsPage.vue?vue&type=script&lang=ts"

import "./FridgePushSettingsPage.vue?vue&type=style&index=0&id=481e3f6a&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481e3f6a"]])

export default __exports__